import { render, staticRenderFns } from "./VeJwQkStudentModal.vue?vue&type=template&id=868b7df4"
import script from "./VeJwQkStudentModal.vue?vue&type=script&lang=js"
export * from "./VeJwQkStudentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports